
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MarkdownComponent, TypographyComponent, TypographyVariant } from '@hyperkit';

@Component({
    standalone: true,
  imports: [CommonModule, TypographyComponent, MarkdownComponent],
  selector: 'report-text-block',
  templateUrl: './report-text-block.component.html',
  styleUrls: ['./report-text-block.component.scss']
})
export class ReportTextBlockComponent {
    @Input() public title = '';
    @Input() public variant: TypographyVariant = 'h4';
    @Input() public value: string = ''; 
}